<template>
     <div class="container">
        <!-- <h3 class="widget-title-sm">Shop by Product</h3>-->
        <h3 class="widget-title-sm">Top Product Categories</h3>
        <div class="owl-carousel owl-products owl-loaded owl-nav-out" data-options='{"items":6,"loop":true,"nav":true}' v-if="recommendedProductCategories.length > 0" >
            
            <div class="owl-item" v-bind:key="category.ProductId" v-for="category in recommendedProductCategories">
                 <router-link class="banner-category owl-item-slide" :to="{ name: 'productsByCategory', params: { id: category.CategoryId }}">
                    <img class="banner-category-img" v-bind:src="category.IconURL" alt="Image Alternative text" title="Image Title" />
                    <!-- <h5 class="banner-category-title">{{category.CategoryName}}</h5> -->
                    <!-- <p class="banner-category-desc">{{category.ShortDescription}}</p> -->
                </router-link>
                <!-- <div class="container">
                    <div class="row">
                        <div class="col">
                           
                        </div>
                    </div>
                </div> -->
                <div class="container">
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-2">
                            <h5 class="banner-category-title">{{category.CategoryName}}</h5>
                        </div>
                    </div>
                </div>          
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	computed: {
		...mapState('categories', [
			'recommendedProductCategories'
		])
    }
}
</script>
